var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#3C890D",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.65 30.1334H23.8V42.1334C23.8 44.9334 25.3167 45.5 27.1667 43.4L39.7834 29.0667C41.3334 27.3167 40.6834 25.8667 38.3334 25.8667H33.1834V13.8667C33.1834 11.0667 31.6667 10.5 29.8167 12.6L17.2 26.9334C15.6667 28.7 16.3167 30.1334 18.65 30.1334Z",
    stroke: "#3C890D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.0255c3fdea2d47fe657ff169485fc8cb.svg";
export { ForwardRef as ReactComponent };